<template>
  <!-- 坐席查询 -->
  <div class="table">
    <div ref="caozuo">
      <el-button size="small" @click="shuaxin">
        <i class="el-icon-refresh-right"></i> 刷新
      </el-button>
      <el-dropdown trigger="click" style="margin-left:10px">
        <el-button size="small">
          <i class="el-icon-download"></i>
          导出
          <i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="daochu3">选定</el-dropdown-item>
          <el-dropdown-item @click.native="daochu">全部</el-dropdown-item>
          <el-dropdown-item @click.native="daochu4">搜索结果</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <div style="float: right">
        <el-form
          style="height: 40px"
          :model="formes"
          :inline="true"
          label-width="90px"
        >
          <el-form-item label>
            <el-date-picker
              v-model="value2"
              size="small"
              value-format="timestamp"
              style="width: 260px"
              type="daterange"
              :picker-options="pickerOptions"
              range-separator="至"
              start-placeholder="创建时间起"
              end-placeholder="创建时间止"
              @change="change"
              align="right"
              :disabled="disabled1"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label>
            <el-select
              v-model="select"
              placeholder="请选择"
              size="small"
              @change="switchover2"
              class="especially"
              style="width:110px;"
            >
              <el-option label="手机号码" value="1"></el-option>
              <el-option label="姓名" value="2"></el-option>
              <el-option label="坐席状态" value="3"></el-option>
            </el-select>
            <!-- 绑定号码 -->
            <el-input
              @input="esarchang"
              size="small"
              placeholder="请输入手机号码号"
              v-model="formes.number_type"
              style="width: 160px"
              class="especially2"
              v-if="this.select == 1"
            >
              <i slot="suffix" class="el-input__icon el-icon-search"></i>
            </el-input>
            <!-- 姓名 -->
            <el-input
              @input="esarchang"
              size="small"
              placeholder="请输入姓名"
              v-model="formes.number_type"
              style="width: 160px"
              class="especially2"
              v-if="this.select == 2"
            >
              <i slot="suffix" class="el-input__icon el-icon-search"></i>
            </el-input>
            <!-- 坐席状态 -->
            <el-select
              v-model="formes.user_state"
              size="small"
              style="width: 160px"
              class="especially2"
              v-if="this.select == 3"
              @change="esarchang"
              filterable
              clearable
              placeholder="请选择坐席状态"
            >
              <el-option :value="0" label="启用"></el-option>
              <el-option :value="1" label="禁用"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <el-table
      :height="zhanshi"
      :data="tableData"
      style="width: 100%"
      :header-cell-style="headerCellStyle"
      @selection-change="handleSelectionChange"
      :cell-style="cellStyle"
      ref="multipleTable"
    >
      <el-table-column type="selection" min-width="35"></el-table-column>
      <el-table-column prop="work_number" label="姓名"></el-table-column>
      <el-table-column prop="user_mobile" label="手机号码"></el-table-column>
      <el-table-column prop="work_number" label="企业用户名"></el-table-column>
      <el-table-column prop="company_name" label="认证企业"></el-table-column>
      <el-table-column prop="ext_id" label="企业分机"></el-table-column>
      <el-table-column prop="work_number" label="工号"></el-table-column>
      <el-table-column prop="group_name" label="部门"></el-table-column>
      <el-table-column prop="group_name" label="通话终端"></el-table-column>
      <el-table-column prop="group_name" label="通话方式"></el-table-column>
      <el-table-column prop="create_time" label="创建时间">
        <template slot-scope="scope">{{
          scope.row.create_time | dateFormat
        }}</template>
      </el-table-column>
      <el-table-column prop="user_state" label="状态">
        <template slot-scope="scope">
          <span :class="[scope.row.user_state == 0 ? 'yellow' : 'red']">
            {{ scope.row.user_state == 0 ? "启用" : "禁用" }}
          </span>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <el-pagination
      class="pagination_bottom"
      background
      layout="total,sizes, prev, pager, next"
      :page-sizes="[20, 50, 100, 200, 300, 400]"
      @size-change="handleSizeChange"
      :total="total"
      :page-size="pagesize"
      @current-change="current_change"
      :current-page="currentPage"
    ></el-pagination>
  </div>
</template>

<script>
import { postData } from "@/api/index";
export default {
  data() {
    return {
      disabled1: false,
      disabled2: false,
      zhanshi: "800px",
      select: "1",
      //搜索
      formes: {
        company_id: "",
        keywords: "",
        start_time: "",
        end_time: "",
        start_valid_time: "",
        end_valid_time: "",
        number_type: "",
        user_state: "",
        page: "",
        pagesize: 20,
      },
      form: {
        group_name: "",
      },
      sousuo: "",
      hujiaofangshi: "",
      tableData: [],
      total: 0, //默认数据总数
      pagesize: 20, //每页的数据条数
      currentPage: 1, //默认开始页面
      startime: "",
      endtime: "",
      value2: [],
      value3: [],
      company_options: [],
      ids: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    };
  },
  created() {
    this.getMainData();
    this.getwearch();
  },
  mounted() {
    setTimeout(() => {
      var caozuo = this.$refs.caozuo.offsetHeight;
      var H = document.body.clientHeight;
      this.zhanshi = H - caozuo - 60 - 38 - 50 - 15;
    }, 100);
    const that = this;
    window.onresize = () => {
      var caozuo = that.$refs.caozuo.offsetHeight;
      var H = document.body.clientHeight;
      that.zhanshi = H - caozuo - 60 - 38 - 50 - 15;
    };
  },
  methods: {
    switchover2() {
      this.formes = {
        company_id: "",
        keywords: "",
        number_type: "",
        user_state: "",
        page: "",
      };
      this.value2 = [];
      this.value3 = [];
      this.currentPage = 1;
      this.esarchang();
    },
    //时间
    change(val) {
      // console.log(val);
      if (val !== null) {
        this.formes.start_time = val[0] / 1000;
        this.formes.end_time = val[1] / 1000;
        this.esarchang();
        // this.disabled2 = true;
      } else {
        this.formes.start_time = "";
        this.formes.end_time = "";
        this.esarchang();
        // this.disabled1 = false;
        // this.disabled2 = false;
      }
    },
    //时间
    change2(val) {
      if (val !== null) {
        this.formes.start_valid_time = val[0] / 1000;
        this.formes.end_valid_time = val[1] / 1000;
        this.esarchang();
        // this.disabled1 = true;
      } else {
        this.formes.start_valid_time = "";
        this.formes.end_valid_time = "";
        this.esarchang();
        // this.disabled1 = false;
        // this.disabled2 = false;
      }
    },
    //搜索
    esarchang() {
      this.formes.page = 1;
      postData("admin/zuoxicxAction", this.formes).then((res) => {
        if (res.code !== 200) {
          this.$message.error(res.msg);
        }
        this.tableData = res.data.data;
        this.total = res.data.total;
        this.pagesize = res.data.per_page;
      });
    },
    getwearch() {
      postData("company/GetSelectAction").then((res) => {
        this.company_options = res.data.company_list;
      });
    },
    headerCellStyle() {
      return "text-align:center;background-color:#F2f2f2;";
    },
    cellStyle() {
      return "text-align:center;";
    },
    // 获取数据
    getMainData() {
      postData("admin/zuoxicxAction", {
        page: this.currentPage,
      }).then((res) => {
        // console.log(res);
        if (res.code !== 200) return this.$message.error(res.msg);
        this.tableData = res.data.data;
        this.total = res.data.total;
        this.pagesize = res.data.per_page;
      });
    },
    //刷新
    shuaxin() {
      this.formes = {
        company_id: "",
        keywords: "",
        number_type: "",
        user_state: "",
        page: "",
      };
      this.value2 = [];
      this.value3 = [];
      this.getMainData();
      this.$message({ message: "刷新成功", type: "success" });
    },
    // 全部导出
    daochu() {
      location.href =
        this.hostName +
        "/admin/zuoxicxAction?excel=1" +
        "&&token=" +
        sessionStorage.getItem("token");
      this.$message.success("正在导出！");
    },
    // 选中导出
    daochu3() {
      // console.log(this.ids);
      if (this.ids.length > 0) {
        location.href =
          this.hostName +
          "/admin/zuoxicxAction?excel=2&&ids=" +
          this.ids +
          "&&token=" +
          sessionStorage.getItem("token");
        this.$message.success("正在导出！");
      } else {
        this.$message({
          message: "请先选择坐席",
          type: "warning",
        });
      }
    },
    // 搜索导出
    daochu4() {
      if (this.tableData.length !== 0) {
        location.href =
          this.hostName +
          "/admin/zuoxicxAction?excel=3" +
          "&&keywords=" +
          this.formes.keywords +
          str +
          "&&pagesize=" +
          this.total +
          "&&token=" +
          sessionStorage.getItem("token");
        this.$message.success("正在导出！");
      } else {
        this.$message.error("请先搜索/数据不能为空");
      }
    },
    handleSelectionChange(val) {
      this.ids = [];
      val.forEach((i) => {
        this.ids.push(i.user_id);
      });
    },
    // 批量启用
    qiyong() {
      if (this.$refs.multipleTable.selection.length !== 0) {
        //  console.log(Array.isArray(this.$refs.multipleTable.selection));
        // console.log(this.$refs.multipleTable.selection);
        this.id = [];
        this.status = [];
        for (let a = 0; a < this.$refs.multipleTable.selection.length; a++) {
          this.id.push(this.$refs.multipleTable.selection[a].user_id);
          this.status.push(this.$refs.multipleTable.selection[a].user_state);
        }
        // console.log(this.id);
        // console.log(this.status);
        // 传递参数
        postData("admin/zuoxiforbAction", {
          id: this.id,
          forb: 0,
        }).then((res) => {
          // console.log(res);
          // 清空数据重新加载
          this.tableData = [];
          this.getMainData("");
          if (res.code !== 200) {
            this.$message({
              type: "info",
              message: res.msg,
            });
          }
          this.$message({
            type: "success",
            message: res.msg,
          });
        });
      } else {
        this.$message({
          type: "warning",
          message: "请选择坐席!",
        });
      }
    },
    // 批量禁用、、
    jingyong() {
      if (this.$refs.multipleTable.selection.length !== 0) {
        //  console.log(Array.isArray(this.$refs.multipleTable.selection));
        // console.log(this.$refs.multipleTable.selection);
        this.id = [];
        this.status = [];
        for (let a = 0; a < this.$refs.multipleTable.selection.length; a++) {
          this.id.push(this.$refs.multipleTable.selection[a].user_id);
          this.status.push(this.$refs.multipleTable.selection[a].user_state);
        }
        // console.log(this.id);
        // console.log(this.status);
        // 传递参数
        postData("admin/zuoxiforbAction", {
          id: this.id,
          forb: 1,
        }).then((res) => {
          // console.log(res);
          // 清空数据重新加载
          this.tableData = [];
          this.getMainData("");
          if (res.code !== 200) {
            this.$message({
              type: "info",
              message: res.msg,
            });
          }
          this.$message({
            type: "success",
            message: res.msg,
          });
        });
      } else {
        this.$message({
          type: "warning",
          message: "请选择坐席!",
        });
      }
    },
    // 状态
    selectout(index, row) {
      // console.log(index, row.user_state);
      this.$confirm("是否切换启用禁用状态?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          postData("admin/zuoxiforbAction", {
            id: row.user_id,
            forb: row.user_state,
          }).then((res) => {
            if (res.code !== 200) {
              this.$message.error(res.msg);
              return true;
            }
            // console.log(res);
            this.$message.success(res.msg);
            this.getMainData();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
          this.getMainData();
        });
    },
    // 分页
    current_change: function(currentPage) {
      // console.log(currentPage);
      this.currentPage = currentPage;
      this.formes.page = currentPage;
      postData("admin/zuoxicxAction", this.formes).then((res) => {
        if (res.code !== 200) {
          this.$message.error(res.msg);
        }
        this.tableData = res.data.data;
        this.total = res.data.total;
        this.pagesize = res.data.per_page;
      });
    },
    handleSizeChange(val) {
      // console.log(val);
      this.formes.pagesize = val;
      this.esarchang();
    },
  },
};
</script>

<style lang="less">
.el-tabs--border-card {
  border: 0;
  box-shadow: none;
}
</style>
<style lang="less" scoped>
.especially /deep/.el-input__inner {
  border-radius: 5px 0 0 5px;
  border-right: 0;
}
.especially2 /deep/.el-input__inner {
  border-radius: 0 5px 5px 0;
  border-left: 0;
}
.especially /deep/.el-input__inner:focus {
  border: 1px solid #c0c4cc;
  border-right: 0;
}
.especially2 /deep/.el-input__inner:focus {
  border: 1px solid #c0c4cc;
  border-left: 0;
}
.el-container {
  display: flex;
  flex-direction: column;
}

.block {
  float: right;
}
.red {
  color: red;
}
p {
  line-height: 20px;
  padding: 0;
  margin: 0;
}
.yellow {
  color: #46c160;
}
.red {
  color: #ec5952;
}
</style>
